import { useNavigate } from "react-router-dom";
import { Trans } from "@lingui/react/macro";
import "./Support.css";
import TallyLogo from "../assets/Tally_Logotype_RGB_Brown.png";

export default function Support() {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <div className="support-container">
      <img
        src={TallyLogo}
        alt="Tally Logo"
        className="viewport-logo"
        onClick={handleLogoClick}
      />

      <header>
        <h1>
          <Trans context="Support page title">Support</Trans>
        </h1>
        <p className="intro">
          <Trans context="Support page introductory subtitle">
            Real ways to reach the Tally team &mdash; no account or sign-in
            required.
          </Trans>
        </p>
      </header>

      <section>
        <h2>
          <Trans context="Support page section heading: contact options">
            Contact options
          </Trans>
        </h2>
        <ul>
          <li>
            <strong>
              <Trans context="Support page: general inquiries contact label">
                General inquiries:
              </Trans>
            </strong>{" "}
            <a href="mailto:info@asktally.com">info@asktally.com</a> &mdash;{" "}
            <Trans context="Support page: general inquiries description">
              for any question about Tally.
            </Trans>
          </li>
          <li>
            <strong>
              <Trans context="Support page: sales inquiries contact label">
                Sales &amp; subscription questions:
              </Trans>
            </strong>{" "}
            <a href="mailto:sales@asktally.com">sales@asktally.com</a> &mdash;{" "}
            <Trans context="Support page: sales inquiries description">
              for pricing, plans, and subscription questions.
            </Trans>
          </li>
          <li>
            <strong>
              <Trans context="Support page: in-app feedback contact label">
                In-app feedback:
              </Trans>
            </strong>{" "}
            <Trans context="Support page: in-app feedback description">
              you can leave feedback directly on any answer inside the app. Our
              developers are instantly notified of errors and review feedback
              regularly.
            </Trans>
          </li>
        </ul>
      </section>

      <section>
        <h2>
          <Trans context="Support page section heading: what to expect">
            What to expect
          </Trans>
        </h2>
        <p>
          <Trans context="Support page: response time and support model description">
            Tally does not have a dedicated support phone line or live chat. Our
            small team monitors incoming emails and in-app feedback closely and
            aims to respond as quickly as possible, typically within one
            business day.
          </Trans>
        </p>
      </section>

      <footer>
        <p>
          <Trans context="Support page footer: link to the help page">
            Looking for documentation or FAQs instead? Visit our{" "}
            <a
              href="/help"
              onClick={(e) => {
                e.preventDefault();
                navigate("/help");
              }}
            >
              Help page
            </a>
            .
          </Trans>
        </p>
      </footer>
    </div>
  );
}
